"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCircuitBreaker = void 0;
var circuitBreaker_1 = require("./circuitBreaker");
var store = new Map();
function getCircuitBreaker(hash, settings) {
    if (store.has(hash)) {
        var circuitBreaker_2 = store.get(hash);
        circuitBreaker_2.setConfig(settings);
        return circuitBreaker_2;
    }
    var circuitBreaker = new circuitBreaker_1.CircuitBreaker(settings);
    store.set(hash, circuitBreaker);
    return circuitBreaker;
}
exports.getCircuitBreaker = getCircuitBreaker;
//# sourceMappingURL=circuitBreakersStore.js.map